import { filterKindLabels } from "../../utils/filterKindUtils";
import { FilterKindOption } from "../FilterKindOption";
import { Menu, MenuItem } from "@mui/material";
import React from "react";
import * as staticDataHooks from "store/hooks/staticDataHooks";

/** Menu offering a choice of filter kind for a column, showing applied filters. */
export const FilterKindMenu = ({
  anchorEl,
  open,
  kinds,
  chipsByKind,
  groupingActive = false,
  onSelect,
  onClose,
  container,
}) => {
  const translateLabels = staticDataHooks.useTranslator("uiLabels");
  const kindLabels = filterKindLabels(translateLabels, groupingActive);
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      container={container ?? undefined}
    >
      {(kinds ?? []).map((kind) => (
        <MenuItem key={kind} dense onClick={() => onSelect(kind)}>
          <FilterKindOption
            label={kindLabels[kind]}
            chips={chipsByKind?.[kind]}
          />
        </MenuItem>
      ))}
    </Menu>
  );
};
export default FilterKindMenu;
